import React, { useEffect, ReactNode } from 'react';
import { Form, Input, Label, Popup } from 'semantic-ui-react';
import { PosFormFieldProps } from '../../types/FormFieldProps';
import Calender from './components/Calendar';
import '../../customStyles/DatePickerInput.less';
import POSIcon from '../POSIcon';

export interface Props extends PosFormFieldProps {
  value?: Range | string;
  locale?: string;
  dateFormat?: Intl.DateTimeFormatOptions;
  minDate?: Date;
  maxDate?: Date;
  errorMessage?: ReactNode;
  onBlur?: (e: any) => void;
  onKeyDown?: (e: any) => void;
}

export const DatePickerInput = (props: Props) => {
  const options: Intl.DateTimeFormatOptions = props.dateFormat || {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  };
  const [open, setOpen] = React.useState(false);
  const [date, setDate] = React.useState<any>();
  const calenderInput = React.createRef<Input>();

  function handleCancel() {
    setOpen(false);
  }

  function handleDateChange(rangeSelection: any) {
    setDate(rangeSelection);
    calenderInput?.current?.focus();
    props.onChange && props.onChange(rangeSelection);
    toggleOpen();
  }

  function toggleOpen() {
    setOpen(!open);
  }

  useEffect(() => {
    if (typeof props.value == 'string' && !!props.value) {
      try {
        const newDate = new Date(props.value);
        setDate(newDate);
      } catch (error) {
        setDate(null);
      }
    } else {
      setDate(props.value);
    }
  }, [props.value]);

  return (
    <Popup
      flowing
      color="red"
      on={'click'}
      open={open}
      onClose={handleCancel}
      position={'bottom left'}
      trigger={
        <Form.Field
          error={props.isError}
          required={props.isMandatory}
          className="calenderFormField"
          placeholder={props.placeholder}
          disabled={props.disabled}
        >
          {props.label && <label>{props.label}</label>}
          <Input
            name="calenderInput"
            ref={calenderInput}
            readOnly
            value={
              date ? `${date.toLocaleDateString(props.locale, options)}` : ''
            }
            onClick={toggleOpen}
            placeholder={props.placeholder}
            icon={
              <POSIcon
                icon="calendar"
                className={`pos calendar`}
                onClick={toggleOpen}
              />
            }
            onBlur={(e: any) => {
              e.stopPropagation();
              props.onBlur?.(e);
            }}
            onKeyDown={(e: any) => {
              e.stopPropagation();
              props.onKeyDown?.(e);
            }}
          ></Input>
          {props.errorMessage && (
            <Label pointing="above" prompt>
              {props.errorMessage}
            </Label>
          )}
        </Form.Field>
      }
    >
      <Calender
        date={date}
        onChange={handleDateChange}
        minDate={props.minDate}
        maxDate={props.maxDate}
      />
    </Popup>
  );
};
